import React from "react";
import { withStyles } from '@material-ui/styles';
import { HashLink } from 'react-router-hash-link';

import I18n from "../../../../base/i18n.js.jsx";

import HtmlContent from "../../../../base/components/html_content.js";

import ButtonLink from "../../../../base/links/button_link.js";
import IlNoProjects from "../resources/illustrations/il_no_projects.js";
import { ProjectsAnchor } from "../../index/constants.js";

import Routes from "../../../routes.js";

const styles = theme => ({
  noProjectsRoot: {
    display: "flex",
    alignItems: "center",
    flexDirection: "column",
    margin: "auto",
    maxWidth: "632px",
    width: "100%"
  },
  noProjectsBtn: {
    display: "block",
    fontSize: "20px",
    padding: "8px 20px",
    textAlign: "center",
    width: "100%",
    ['@media (max-width: 768px)']: {
      fontSize: "18px",
      padding: "10px 20px",
    }
  },
  noProjectsImg: {
    margin: "85px 0",
    width: "auto",
    maxWidth: "100%",
    ['@media (max-width: 768px)']: {
      padding: "0 35px",
      margin: "10px auto 25px"
    }
  },
  noProjectsTitle: {
    fontSize: "38px",
    marginBottom: "15px",
    ['@media (max-width: 768px)']: {
      fontSize: "20px",
    }  
  },
  noProjectsText: {
    fontSize: "20px",
    fontWeight: theme.typography.fontWeightLight,
    ['@media (max-width: 768px)']: {
      fontSize: "14px",
    }  
  },
  hashLink: {
    color: "inherit",
    display: "block",
    textDecoration: "inherit",
    margin: "60px auto 30px",
    maxWidth: "410px",
    width: "100%",
    ['@media (max-width: 768px)']: {
      margin: "38px auto 36px",
    }
  }
})

const NoProjectsBlock = props => {
  const { classes } = props;

  return(
    <div className = { classes.noProjectsRoot }>
      <IlNoProjects className = { classes.noProjectsImg } />
      <div className = { classes.noProjectsTitle }>
        { I18n.t("web.page.profile.empty.title") }
      </div>
      <HtmlContent className = { classes.noProjectsText }>
        { I18n.t("web.page.profile.empty.text") }
      </HtmlContent>
      <HashLink to = { Routes.index({anchor: ProjectsAnchor}) }
                className = { classes.hashLink } >
        <ButtonLink className = { classes.noProjectsBtn }
                    smooth
                    component = { "div" } >  
          { I18n.t("action.go_to_invest") }
        </ButtonLink>
      </HashLink> 
    </div>
  )
}

export default withStyles(styles)(NoProjectsBlock);